"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var LabelAfter = function (_a) {
    var className = _a.className, duration = _a.duration, frequency = _a.frequency;
    return (<core_1.Typography variant="subtitle2" className={className} component="span">
      <Translation_1.default id="trans__checkout__confirmation_page__summary__finance_payment_details" values={{ duration: duration, frequency: frequency }}/>
    </core_1.Typography>);
};
exports.default = LabelAfter;
